import { Directive, ElementRef, HostListener, inject, Input, OnDestroy } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { NamesTooltipComponent } from '@shared/ui/names-tooltip/names-tooltip.component';

@Directive({
  selector: '[appInfoTooltip]',
  standalone: true
})
export class InfoTooltipDirective implements OnDestroy {
  @Input('appInfoTooltip') items: string[] = [];

  private overlay = inject(Overlay);
  private el = inject(ElementRef);
  private overlayRef: OverlayRef | null = null;

  @HostListener('mouseenter')
  onMouseEnter() {
    if (!this.items.length) return;

    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(this.el)
      .withPositions([
        { originX: 'center', originY: 'top', overlayX: 'center', overlayY: 'bottom', offsetY: -8 },
        { originX: 'center', originY: 'bottom', overlayX: 'center', overlayY: 'top', offsetY: 8 }
      ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.reposition(),
    });

    const ref = this.overlayRef.attach(new ComponentPortal(NamesTooltipComponent));
    ref.setInput('names', this.items);
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.close();
  }

  ngOnDestroy() {
    this.close();
  }

  private close() {
    this.overlayRef?.dispose();
    this.overlayRef = null;
  }
}
